var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":{ name: 'users.edit', params: { id: _vm.user.id } }}},[(_vm.user.company_id)?_c('i',{staticClass:"icon-office"}):_vm._e(),_vm._v(" "+_vm._s(_vm.user.name)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }